var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M0 382.4h500v.25H0zM237 337.8H43.91a5.71 5.71 0 0 1-5.7-5.71V60.66a5.71 5.71 0 0 1 5.7-5.66H237a5.71 5.71 0 0 1 5.71 5.71v271.38a5.71 5.71 0 0 1-5.71 5.71ZM43.91 55.2a5.46 5.46 0 0 0-5.45 5.46v271.43a5.46 5.46 0 0 0 5.45 5.46H237a5.47 5.47 0 0 0 5.46-5.46V60.66A5.47 5.47 0 0 0 237 55.2ZM453.31 337.8h-193.1a5.72 5.72 0 0 1-5.71-5.71V60.66a5.72 5.72 0 0 1 5.71-5.66h193.1a5.71 5.71 0 0 1 5.69 5.66v271.43a5.71 5.71 0 0 1-5.69 5.71ZM260.21 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.47 5.47 0 0 0 5.46 5.46h193.1a5.47 5.47 0 0 0 5.46-5.46V60.66a5.47 5.47 0 0 0-5.46-5.46ZM423.9 398.49h26v.25h-26zM311 401.21h45.03v.25H311zM362.11 389.21h60.79v.25h-60.79zM52.46 390.89h19.23v.25H52.46zM80.6 390.89h55.29v.25H80.6zM169.67 395.11h74.47v.25h-74.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M46.24 309.02h21.2v73.38h-21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M64.8 325.12H86v57.28H64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M78.36 277.92h21.2V382.4h-21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M92.45 193.2h21.2v189.2h-21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M109.2 207.93h56.89V382.4H109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 399.385 357.29)",
    style: {
      fill: "#fafafa"
    },
    d: "M387.27 332.18h24.22v50.22h-24.22z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 378.17 362.795)",
    style: {
      fill: "#fafafa"
    },
    d: "M366.06 343.19h24.22v39.2h-24.22z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 362.685 346.645)",
    style: {
      fill: "#fafafa"
    },
    d: "M350.57 310.89h24.22v71.51h-24.22z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 346.585 317.655)",
    style: {
      fill: "#fafafa"
    },
    d: "M334.47 252.91h24.22V382.4h-24.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M273.17 224.21h74.33V382.4h-74.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5"
    },
    d: "M336.88 230.84h3.54v19.25h-3.54zM336.88 260.95h3.54v19.25h-3.54zM336.88 291.05h3.54v19.25h-3.54zM336.88 321.15h3.54v19.25h-3.54zM336.88 351.26h3.54v19.25h-3.54zM324.34 230.84h3.54v19.25h-3.54zM324.34 260.95h3.54v19.25h-3.54zM324.34 291.05h3.54v19.25h-3.54zM324.34 321.15h3.54v19.25h-3.54zM324.34 351.26h3.54v19.25h-3.54zM311.8 230.84h3.54v19.25h-3.54zM311.8 260.95h3.54v19.25h-3.54zM311.8 291.05h3.54v19.25h-3.54zM311.8 321.15h3.54v19.25h-3.54zM311.8 351.26h3.54v19.25h-3.54zM299.26 230.84h3.54v19.25h-3.54zM299.26 260.95h3.54v19.25h-3.54zM299.26 291.05h3.54v19.25h-3.54zM299.26 321.15h3.54v19.25h-3.54zM299.26 351.26h3.54v19.25h-3.54zM286.71 230.84h3.54v19.25h-3.54zM286.71 260.95h3.54v19.25h-3.54zM286.71 291.05h3.54v19.25h-3.54zM286.71 321.15h3.54v19.25h-3.54zM286.71 351.26h3.54v19.25h-3.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      opacity: 0.5
    },
    d: "M273.17 224.21h15.31l6.66 158.19h-21.97V224.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "m236.63 163.09 44.08 8.34V382.4h-44.08V163.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "M201.36 163.09h35.27V382.4h-35.27z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 181.825)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 181.26h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 193.765)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 193.2h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 205.705)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 205.14h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 217.645)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 217.09h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 229.59)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 229.03h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 241.53)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 240.97h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 253.47)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 252.91h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 265.41)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 264.85h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 277.355)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 276.79h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 289.295)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 288.73h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 301.235)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 300.67h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 313.175)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 312.62h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 325.12)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 324.56h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 337.06)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 336.5h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 349)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 348.44h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 360.94)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 360.38h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 241.035 372.885)",
    style: {
      fill: "#e0e0e0"
    },
    d: "M201.36 372.32h79.35v1.12h-79.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M145.2 116.48h36.87V382.4H145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M182.07 116.48H145.2L158.77 93h52.8l-29.5 23.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M182.07 116.48 211.57 93v289.4h-29.5V116.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0"
    },
    d: "M145.2 128.87h66.37v1.42H145.2zM145.2 143.92h66.37v1.42H145.2zM145.2 158.97h66.37v1.42H145.2zM145.2 174.03h66.37v1.42H145.2zM145.2 189.08h66.37v1.42H145.2zM145.2 204.13h66.37v1.42H145.2zM145.2 219.18h66.37v1.42H145.2zM145.2 234.23h66.37v1.42H145.2zM145.2 249.28h66.37v1.42H145.2zM145.2 264.34h66.37v1.42H145.2zM145.2 279.39h66.37v1.42H145.2zM145.2 294.44h66.37v1.42H145.2zM145.2 309.49h66.37v1.42H145.2zM145.2 324.54h66.37v1.42H145.2zM145.2 339.59h66.37v1.42H145.2zM145.2 354.65h66.37v1.42H145.2zM145.2 369.7h66.37v1.42H145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M98.55 245.16h40.25V382.4H98.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "M106.47 252.25h6.46v22.03h-6.46zM122.32 252.25h6.46v22.03h-6.46zM106.47 280.78h6.46v22.03h-6.46zM122.32 280.78h6.46v22.03h-6.46zM106.47 309.3h6.46v22.03h-6.46zM122.32 309.3h6.46v22.03h-6.46zM106.47 337.83h6.46v22.03h-6.46zM122.32 337.83h6.46v22.03h-6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M138.79 245.16H98.55l9.44-9.51h40.25l-9.45 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m138.79 245.16 9.45-9.51 9.44 9.51V382.4h-18.89V245.16z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.13,
    y: 114.58,
    width: 146.11,
    height: 301.65,
    rx: 9.29,
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.35,
    y: 114.58,
    width: 146.11,
    height: 301.65,
    rx: 9.29,
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.35,
    y: 114.58,
    width: 146.11,
    height: 301.65,
    rx: 9.29,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M295.77 114.58h7.91v301.65h-7.91zM382.52 114.58h4.85v301.65h-4.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M274.35 180.1v7.91l146.11-9.05v-7.91l-146.11 9.05z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 347.41 370.92)",
    style: {
      fill: "#fff"
    },
    d: "M343.45 297.87h7.91v146.11h-7.91z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 347.41 221.74)",
    style: {
      fill: "#fff"
    },
    d: "M345.25 148.68h4.31v146.11h-4.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M274.35 321.56v9.06l146.11-49.44v-9.06l-146.11 49.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M325.56 114.58h-7.91l21.26 301.66h7.91l-21.26-301.66z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395 385.29H221.05v-54.22h153.33l14.31 11.63A17.06 17.06 0 0 1 395 356Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 385.29H221.05v-54.22h153.33l14.31 11.63A17.06 17.06 0 0 1 395 356Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05 380.4c0-19.79 9-35.83 20-35.83h-21.22c-11.07 0-20 16-20 35.83s9 35.84 20 35.84h21.26c-11.09 0-20.04-16.05-20.04-35.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.09,
    cy: 380.4,
    rx: 20.04,
    ry: 35.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.7,
    cy: 380.4,
    rx: 14.21,
    ry: 27.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.54 380.4c0-19.79 9-35.83 20-35.83h-21.22c-11.07 0-20 16-20 35.83s9 35.84 20 35.84h21.26c-11.07 0-20.04-16.05-20.04-35.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.58,
    cy: 380.4,
    rx: 20.04,
    ry: 35.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.38 380.4c0-19.79 9-35.83 20-35.83h-21.22c-11.06 0-20 16-20 35.83s9 35.84 20 35.84h21.26c-11.06 0-20.04-16.05-20.04-35.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.42,
    cy: 380.4,
    rx: 20.04,
    ry: 35.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.04,
    cy: 380.4,
    rx: 14.21,
    ry: 27.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.37 390.4h-25.71l-1.44-1.4a7.9 7.9 0 0 0-5.58-2.32H99.38A7.9 7.9 0 0 0 93.8 389l-.88.87h-2.34A13.8 13.8 0 0 1 76.78 376v-21.15H222.6L211 380.07a15.5 15.5 0 0 1-14.63 10.33Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.37 390.4h-25.71l-1.44-1.4a7.9 7.9 0 0 0-5.58-2.32H99.38A7.9 7.9 0 0 0 93.8 389l-.88.87h-2.34A13.8 13.8 0 0 1 76.78 376v-21.15H222.6L211 380.07a15.5 15.5 0 0 1-14.63 10.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16 264.68a.45.45 0 0 1-.25-.07.49.49 0 0 1-.18-.68l7-12a.5.5 0 1 1 .86.5l-7 12a.5.5 0 0 1-.43.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.08 324.38v-13.64c0-7.17-10.42-41-24.75-47.34s-49-9.16-70.84-8-51 46.84-51 46.84l3.17 39.28c4.44 0 18.58-1.34 20.65 37.52A10.68 10.68 0 0 0 273 389.18h76.46A10.65 10.65 0 0 0 360 380c2-13.85 7.22-38.51 19.81-38.51 8.83 0 15.16 7.56 15.16 16.23a58.76 58.76 0 0 0-6.74-27.34Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.49 255.4c-39.77 0-84.83 46.84-84.83 46.84h113.87s29.13-45.67 51-46.84Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.93 255.4c-33.5 0-68.64 33.24-78.89 43.71a1.84 1.84 0 0 0 1.32 3.13h91.86a23.5 23.5 0 0 0 19-9.58c9.88-13.46 28.91-36.43 44.31-37.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.53 302.24-42.06 33.19-113.19-.36s-6.5 9.45-6.5 19.78H222.6c2.39-6.33 10.77-13.33 19.1-13.33 0-11.78-3.17-39.28-3.17-39.28Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 325.65a.5.5 0 0 1-.49-.43.5.5 0 0 1 .42-.56 55.5 55.5 0 0 0 27.3-12.7 8.06 8.06 0 0 0 1.45-10.74.5.5 0 1 1 .82-.57 9.07 9.07 0 0 1-1.63 12.07 56.34 56.34 0 0 1-27.79 12.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.28 335.07s19.88-23.17 41.38-32.83h113.87l-42.06 33.19Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M96.66 335.07h74.67v2.17H96.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.78 330.73 4-4a6.64 6.64 0 0 1 3.28-1.79l30.21-6.58a6.58 6.58 0 0 1 3.21.1l1.62.45a6.64 6.64 0 0 1 3.2 10.76l-6.5 7.43a6.66 6.66 0 0 1-4.38 2.24L175.09 342a6.62 6.62 0 0 1-5.3-1.9 6.64 6.64 0 0 1-.01-9.37ZM98.77 332.85l-3.31-6.19a5.48 5.48 0 0 0-2-2.1 5.44 5.44 0 0 0-5.33-.15l-2.51 1.32A5.47 5.47 0 0 0 83 328.8l-1.53 4.53a5.45 5.45 0 0 0 4.23 7.13l6.91 1.19a5.45 5.45 0 0 0 5.73-2.79l.46-.85a5.43 5.43 0 0 0-.03-5.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79 303.57h105.28a5.72 5.72 0 0 0 5.48-7.37c-2.4-8-7-20.51-13.91-26.89a5.81 5.81 0 0 0-2.73-1.4c-12.41-2.63-32.36-4.38-47.16-5.4a46.56 46.56 0 0 0-36.41 13.84 128.09 128.09 0 0 0-15.19 18.53 5.59 5.59 0 0 0 4.64 8.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.72 366.57c0 3.28-3.36 5.95-7.5 5.95s-7.5-2.67-7.5-5.95 3.35-5.94 7.5-5.94 7.5 2.66 7.5 5.94ZM133.29 330.53c2.46 0 3.66 2.52 2.68 5.62s-3.76 5.63-6.23 5.63-3.66-2.52-2.68-5.63 3.77-5.62 6.23-5.62ZM82.83 366.57c0 3.28-1 5.95-2.11 5.95s-2.12-2.67-2.12-5.95 1-5.94 2.12-5.94 2.11 2.66 2.11 5.94ZM258.55 302.62v-3.37a6.5 6.5 0 0 1 7.83-6.37l12.82 2.67a6.51 6.51 0 0 1 5.18 6.37v.7a6.51 6.51 0 0 1-6.5 6.51h-12.82a6.51 6.51 0 0 1-6.51-6.51ZM326 263.91s-1.71-.17-4.69-.43c13.18 27 9.82 40.09 9.82 40.09h10.06c.1-16.44-15.19-39.66-15.19-39.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.84 291.48a8.58 8.58 0 0 1-8.53 7.76h-51.83c-3.78 0-5.15-4.22-2.41-7.36a146.37 146.37 0 0 1 16.06-15.68c9.76-8.22 21.88-12.49 33.21-11.7l4.28.31a8.6 8.6 0 0 1 7.74 6.77 65.14 65.14 0 0 1 1.48 19.9Z",
    style: {
      fill: "#ffc100",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.33 382.07a.5.5 0 0 1-.5-.5c0-10.12 5.16-51.85 6.51-58.1 1.31-6.07 1.31-12.85 0-17.26a.5.5 0 0 1 .34-.62.51.51 0 0 1 .62.34c1.35 4.56 1.35 11.53 0 17.75s-6.49 47.81-6.49 57.89a.5.5 0 0 1-.48.5ZM331 324h-12.19a1.51 1.51 0 0 1-1.52-1.85l.25-1.41a2.3 2.3 0 0 1 2.17-1.85h12.19a1.51 1.51 0 0 1 1.52 1.85l-.25 1.41A2.3 2.3 0 0 1 331 324Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.88 172.48h-1a26.46 26.46 0 0 0-1.09-7.52l1-.28a27.35 27.35 0 0 1 1.09 7.8Zm-4.31-12.79a26.46 26.46 0 0 0-23.07-13.58v-1a27.42 27.42 0 0 1 23.94 14.1Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 148.61a23.87 23.87 0 0 0-23.86 23.87c0 23 23.86 38.76 23.86 38.76s23.88-15.77 23.88-38.76a23.88 23.88 0 0 0-23.88-23.87Zm0 35.11a11.14 11.14 0 1 1 11.15-11.14 11.14 11.14 0 0 1-11.15 11.14Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b55b52"
    },
    d: "m297.97 414.72 6.04-.1 1.74-14-6.03.1-1.75 14zM326.8 414.27l5.86-1.79-3.64-13.27-5.86 1.8 3.64 13.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.48 410.72-6.54 3.37a.53.53 0 0 0-.26.61l1.4 5.31a.88.88 0 0 0 1.27.55c2.09-1.12 3.56-2 6.21-3.41 1.63-.84 6.63-3.2 8.88-4.37s1.4-3.54.38-3.26c-4.6 1.23-8.36 1.59-10.3 1.08a1.44 1.44 0 0 0-1.04.12ZM304.13 413.92l-6.59.11a.52.52 0 0 0-.5.42l-1.11 5.38a.87.87 0 0 0 .88 1.06c2.38-.08 5.81-.27 8.8-.32 3.49-.05 4.51.09 8.61 0 2.47 0 3.12-2.56 2.08-2.77-4.74-1-6.59-1-10.7-3.46a3 3 0 0 0-1.47-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3 231.05c1.37 2.75 2.92 5.66 4.47 8.43s3.19 5.53 4.94 8.12c.45.64.87 1.31 1.33 1.92l1.13 1.54c.23.3.36.44.4.51s.06.17.35.19a5.79 5.79 0 0 0 2.85-1.4c.55-.42 1.11-.9 1.66-1.41s1.1-1.1 1.58-1.57l3.99 2.22a20.23 20.23 0 0 1-1.18 2.57 17.56 17.56 0 0 1-1.54 2.42 14.29 14.29 0 0 1-2.1 2.28 9.8 9.8 0 0 1-3.17 1.89 7.85 7.85 0 0 1-4.56.25 9 9 0 0 1-3.82-2 8.63 8.63 0 0 1-.69-.65l-.32-.33-.23-.26-.88-1c-.59-.67-1.13-1.36-1.69-2a87.4 87.4 0 0 1-5.9-8.6c-.88-1.48-1.75-3-2.55-4.49s-1.58-3-2.32-4.69Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.48 231.09c-1.63 5.54 9.82 20.63 9.82 20.63l11.55-7.43a73.68 73.68 0 0 0-8-13.58c-4.73-6.03-11.59-5.71-13.37.38Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.48 231.09c-1.63 5.54 9.82 20.63 9.82 20.63l11.55-7.43a73.68 73.68 0 0 0-8-13.58c-4.73-6.03-11.59-5.71-13.37.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.52 237.59c2.37 1 5.87 6.74 7.69 11l-4.9 3.15a91.41 91.41 0 0 1-7.37-11.55c1.55-1.72 3.32-3.13 4.58-2.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.32 248.46 4.18-6.76 3.65 5.83a7.19 7.19 0 0 1-4 3.29ZM341.33 241.77v2.09a2.82 2.82 0 0 1-.64 1.79l-1.52 1.88-3.65-5.83 3.77-1.37a1.53 1.53 0 0 1 2.04 1.44Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc100"
    },
    d: "m337.25 250.41-6.58-.1 3.64-13.63 6.58.1-3.64 13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m337.92 250.41-6.58-.1 3.64-13.63 6.58.1-3.64 13.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "m305.75 400.63-.9 7.21-6.04.1.9-7.22 6.04-.09zM323.16 401.01l5.87-1.8 1.87 6.84-5.87 1.8-1.87-6.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 234c4.93 21.22 3.86 42.27 4.4 46.81l32.19-2.4c3.09-34.49-4.23-52-4.23-52s-2.07-.4-4.88-.69c-.88-.09-1.84-.17-2.83-.22-.55 0-1.1-.05-1.67-.06a119.5 119.5 0 0 0-13.68 1c-.86.11-1.73.23-2.58.37l-2.28.42h-.09A5.59 5.59 0 0 0 277 234Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 234c4.93 21.22 3.86 42.27 4.4 46.81l32.19-2.4c3.09-34.49-4.23-52-4.23-52s-2.07-.4-4.88-.69c-.88-.09-1.84-.17-2.83-.22-.55 0-1.1-.05-1.67-.06a119.5 119.5 0 0 0-13.68 1c-.86.11-1.73.23-2.58.37l-2.28.42h-.09A5.59 5.59 0 0 0 277 234Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.45 238.48-3.7 4.75a1.1 1.1 0 0 1 0 .18c.52 3.22.92 6.37 1.22 9.41 3.55-4.37 3.03-12.26 2.48-14.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.85 217.06c.77 3.24.72 6.84-1.6 9.42 2.57 2.2 5.9 4.71 11.14 4.51s4.07-3.74 2.54-5.53c-4.47-.72-4.48-3.63-4.52-6.83a1.53 1.53 0 0 0-1.07-1.45l-4.92-1.58a1.23 1.23 0 0 0-1.57 1.46Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 251.67c-2.7 0-5.19-3.24-5.68-7.38a8.21 8.21 0 0 1 1.49-6.3 3.37 3.37 0 0 1 2.56-1.22c2.69 0 5.19 3.24 5.67 7.38a8.22 8.22 0 0 1-1.48 6.3 3.42 3.42 0 0 1-2.56 1.22Zm-1.62-13.9a2.37 2.37 0 0 0-1.81.89 7.28 7.28 0 0 0-1.24 5.51c.41 3.53 2.55 6.5 4.68 6.5a2.37 2.37 0 0 0 1.82-.89 7.32 7.32 0 0 0 1.24-5.51c-.39-3.53-2.53-6.5-4.65-6.5Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.42 218.81-4.95.64c.11.22.25.43.38.64.94 1.5 3 2.49 5.14 2.85a10.53 10.53 0 0 1-.57-4.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.84 206c2.75.46 7.89-2.66 6.69-6.82-1.54 1.93-6.69 1.28-6.69 1.28ZM291.1 210.4c.3 2.78-3.13 7.73-7.21 6.28 2-1.42 1.68-6.61 1.68-6.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.07 205c-.74 5.94-1.48 9.39.93 13 3.61 5.37 11.37 4 13.87-1.57 2.25-5 3.08-13.91-2.24-17.33a8.17 8.17 0 0 0-12.56 5.9Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25 211c1.45 1.53 5.44-4.72 4.71-7 1.5.66 4.38-.6 4.2-3.08 4.49 2.4 11 4.3 11.1 0s-4-7.55-8-7.89c.48 1.29-.79 1.84-3.4 1.29s-12.67-5.18-11.56 4.07c-3.76.22-4.25 4.98 2.95 12.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.31 208.69a5.69 5.69 0 0 0 2.2 3.75c1.6 1.19 2.6-.07 2.75-1.95.14-1.7 0-4.36-1.91-4.81a2.55 2.55 0 0 0-3.04 3.01Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.38 280 21.16-1.57s2.74 43.43 2.53 61.84c-.21 19.16-9 66.13-9 66.13l-10.22.16s.81-45.56.81-64.37c0-25.33-5.31-62.19-5.31-62.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.56 325.15c.28 1.25 8.15 36.46 10.69 57 1.35-8.54 2.74-18.13 3.68-26.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.12 279.29s16.11 39.46 19.74 56.77c4 18.95 10.35 66.88 10.35 66.88l-10.93 1.7s-8.27-35.83-12.9-54.13c-5.26-20.86-26.12-53.89-27-69.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc100"
    },
    d: "M333.58 403.87 320 407.05l-1.71-5.23 14.83-2.54.46 4.59zM308.39 406.63l-12.18.19-.06-3.93 13.6-.42-1.36 4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.35 208.08c-.09.48.09.91.4 1s.64-.28.73-.76-.09-.91-.41-1-.63.28-.72.76ZM301.27 209.34c-.09.47.09.91.4 1s.64-.28.73-.76-.09-.92-.4-1-.64.28-.73.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32 209.22a17.41 17.41 0 0 0 1.52 4.52 2.82 2.82 0 0 1-2.37 0Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46 215.21a4 4 0 0 1-2.6-1.83.15.15 0 0 1 .06-.2.15.15 0 0 1 .19.06 3.87 3.87 0 0 0 3 1.78.15.15 0 0 1 0 .29 3.83 3.83 0 0 1-.65-.1ZM294.76 205.94a.57.57 0 0 1-.13-.08.31.31 0 0 1 0-.41 2.87 2.87 0 0 1 2.51-.73.29.29 0 0 1 .2.35.28.28 0 0 1-.34.2 2.29 2.29 0 0 0-2 .61.29.29 0 0 1-.24.06ZM304.46 207.85a.29.29 0 0 1-.19-.2 2.22 2.22 0 0 0-1.34-1.56.29.29 0 0 1-.19-.36.29.29 0 0 1 .36-.19 2.83 2.83 0 0 1 1.72 2 .27.27 0 0 1-.2.35.22.22 0 0 1-.16-.04Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.74 410.74a7 7 0 0 1-1.5.53.12.12 0 0 1-.15 0 .14.14 0 0 1 0-.16c.13-.22 1.31-2.18 2.06-2.18a.46.46 0 0 1 .41.25.87.87 0 0 1 .08.81 1.86 1.86 0 0 1-.9.75Zm-1.23.16a2.93 2.93 0 0 0 1.86-1.07.58.58 0 0 0-.07-.55c-.06-.1-.11-.11-.16-.11-.39 0-1.14.97-1.63 1.73Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.27 411.26h-.08a.16.16 0 0 1-.12-.09 4.29 4.29 0 0 1-.34-2.51.81.81 0 0 1 .46-.45.46.46 0 0 1 .57.13c.43.54 0 2.27-.44 2.86a.1.1 0 0 1-.05.06Zm0-2.73a.51.51 0 0 0-.24.26 3.47 3.47 0 0 0 .24 2c.33-.71.56-1.95.31-2.26 0 0-.08-.1-.25 0ZM304.74 414.75a.14.14 0 0 1 0-.26c.27-.15 2.68-1.42 3.42-1a.48.48 0 0 1 .24.38.82.82 0 0 1-.26.7c-.65.59-2.38.38-3.36.2Zm3.26-1.05a5.94 5.94 0 0 0-2.72.84 3.93 3.93 0 0 0 2.7-.2.52.52 0 0 0 .16-.47.16.16 0 0 0-.09-.15Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.74 414.75a.16.16 0 0 1-.06-.13 4.17 4.17 0 0 1 .9-2.34 1.1 1.1 0 0 1 .79-.26c.4 0 .51.24.54.4.12.68-1.3 2-2 2.34a.14.14 0 0 1-.17-.01Zm1.71-2.43a.26.26 0 0 0-.14 0 .73.73 0 0 0-.58.19 3.34 3.34 0 0 0-.77 1.87c.74-.45 1.7-1.5 1.63-1.9 0-.06-.02-.12-.14-.16Zm-.13-.17Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.61 235.88c-2 3.55-4 7.34-5.8 11.07a86.66 86.66 0 0 0-4.65 11.28c-.15.47-.26.93-.4 1.39-.05.21-.14.51-.17.65a3.59 3.59 0 0 0-.08.35 5.84 5.84 0 0 0 .05 1.89 17.56 17.56 0 0 0 1.95 4.87 61.19 61.19 0 0 0 7.22 9.79l-2.9 3.48a43.73 43.73 0 0 1-10.18-9.35 22.49 22.49 0 0 1-3.67-6.76 13 13 0 0 1-.63-4.53c0-.41.08-.84.13-1.25s.11-.62.17-.94c.12-.58.23-1.19.36-1.76a76 76 0 0 1 4.54-12.94 110.57 110.57 0 0 1 6.2-11.92Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33 227.69c-5.57 1.53-11 17.18-11 17.18l13.41 3.72a43.21 43.21 0 0 0 5.57-10.72c2.82-7.61-1.24-12.02-7.98-10.18Z",
    style: {
      fill: "#ffc100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33 227.69c-5.57 1.53-11 17.18-11 17.18l13.41 3.72a43.21 43.21 0 0 0 5.57-10.72c2.82-7.61-1.24-12.02-7.98-10.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.16 276.14 6.12 1.61-2.43 5.75s-5.49-1.16-5.46-4.15Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b55b52"
    },
    d: "m290.63 281.65-1.81 4.55-2.97-2.7 2.43-5.75 2.35 3.9z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar1);
export default __webpack_public_path__ + "static/media/car1.5faf58a351e7272da4f3e90d98df3aa1.svg";
export { ForwardRef as ReactComponent };